import React from "react";

import styled from "styled-components";

import Container from "../shared/container";

import { __t } from "../../utils/translate";
import { Product } from "../../utils/types";

type SizeChartProps = {
    product: Product;
    className: string;
};
type MeasureProps = {
    measure?: {};
    measure_steps?: {};
};

const MeasureTable = styled.div`
  & thead tr *{
    text-transform: lowercase;
    font-weight: 400;
  }
  & thead tr:first-child *{
    text-transform: uppercase;
    font-weight: 600;
  }
  & strong{
    font-weight: 500;
  }
`;

const MeasureSteps = styled.div`
& strong{
  font-weight: 500;
}
`;

const Measure: React.FC<MeasureProps> = ({
    measure,
    measure_steps
}) => {
    return (
        !!measure && <div className={`flex flex-col text-center justify-center mb-2`}>
            {!!measure.header &&
                <h3 className="text-h2-r md:text-h2 text-main-text-color mb-5 md:mb-[30px]">
                    {measure.header}
                </h3>
            }

            {(!!measure.image || !!measure.sub_header || !!measure_steps?.length) &&
                <div className="flex flex-col items-start md:flex-row gap-[10px] max-w-[1060px] mx-auto mb-5">
                    {!!measure.image && (
                        <img className={`${!!measure_steps ?'md:w-[55%]' :''} mb-3 md:mb-1 w-full object-contain`} src={measure.image.url} loading="lazy" alt={measure.image.alt ? measure.image.alt : ''}></img>
                    )}
                    <div className="text-start text-wrap">
                        {!!measure.sub_header && (
                            <h4 className="text-base-16-strong mb-2 uppercase text-main-text-color ">
                                {measure.sub_header}
                            </h4>
                        )}
                        {!!measure_steps?.length && (
                            <MeasureSteps className="text-base-16 text-body-text-color ">
                                {measure_steps.map((item: any, index) => {
                                    return (
                                        <div key={index} className="mb-1" dangerouslySetInnerHTML={{ __html: item.step }}></div>
                                    );
                                })
                                }
                            </MeasureSteps>
                        )}
                    </div>
                </div>
            }
            {!!measure.table && (
                <div className="gap-6 md:gap-8 xl:gap-10 flex flex-col">
                    <MeasureTable className="sizes-table w-full measure-table" dangerouslySetInnerHTML={{ __html: measure.table }}></MeasureTable>
                </div>
            )}
        </div>
    )
};

const SizeChart: React.FC<SizeChartProps> = ({
    product,
    className,
}) => {
    let size_guide = {};
    !!product.acf.size_guide.url 
        ? size_guide = { 'image': product.acf.size_guide }
        : null

    !!product.acf.size_eyewear.url
        ? size_guide = { 'image': product.acf.size_eyewear }
        : null

    return (
        <Container>
            <div className={`flex flex-col text-center justify-center gap-0 ${className}`}>
                {!!size_guide && (
                    <Measure measure={size_guide} measure_steps={null} />
                )}
                {!!product.acf.measure && (
                    <Measure measure={product.acf.measure} measure_steps={product.acf.measure_steps} />
                )}
                { !!product.acf.measure2 && (
                    <Measure measure={product.acf.measure2} measure_steps={product.acf.measure_steps2} />
                )}
                { !!product.acf.measure3 && (
                    <Measure measure={product.acf.measure3} measure_steps={product.acf.measure_steps3} />
                )} 
                {product.acf.sizeguide.image && (
                    <img src={product.acf.sizeguide.image} loading="lazy" alt={product.acf.sizeguide.image.alt ? product.acf.sizeguide.image.alt : ''} />
                )}
            </div>
        </Container>
    )
};

export default SizeChart;
